import { PreferencesRepository } from '../repositories/preferences.repository'
import {
    CreateDealPayload,
    GetLeadFullResponse,
    GetLeadsParams,
    GetLeadsResponse,
    GetPreferencesParams,
    GetPreferencesResponse,
    GetSourcesResponse,
    GetThemesResponse,
    PreferencesDownloadExcelResponse,
} from '../types/preferences.types'

const preferencesRepository = new PreferencesRepository()

export class PreferencesService {
    async getList(params: GetPreferencesParams): Promise<GetPreferencesResponse> {
        const response = await preferencesRepository.getList(params)
        return response.data
    }

    async getLeadsList(params: GetLeadsParams): Promise<GetLeadsResponse> {
        const response = await preferencesRepository.getLeadsList(params)
        return response.data
    }

    async getThemes(): Promise<GetThemesResponse> {
        const response = await preferencesRepository.getThemes()
        return response.data
    }

    async getSources(): Promise<GetSourcesResponse> {
        const response = await preferencesRepository.getSources()
        return response.data
    }

    async exportExcel(params: GetPreferencesParams): Promise<PreferencesDownloadExcelResponse> {
        const response = await preferencesRepository.exportExcel(params)
        return response.data
    }

    async exportLeadsExcel(params: GetLeadsParams): Promise<PreferencesDownloadExcelResponse> {
        const response = await preferencesRepository.exportLeadsExcel(params)
        return response.data
    }

    async getLead(id: number): Promise<GetLeadFullResponse> {
        const response = await preferencesRepository.getLead(id)
        return response.data
    }

    async createDeal(payload: CreateDealPayload): Promise<void> {
        const response = await preferencesRepository.createDeal(payload)
        return response.data
    }
}
